// ============================================
// Path: /frontend/src/api/listings.api.js
// Purpose: Listings API endpoints
// ============================================

import apiClient from './client.js';

export const listingsAPI = {
  // Get all listings with filters
  getListings: async (filters = {}) => {
    const params = new URLSearchParams(filters).toString();
    const response = await apiClient.get(`/listings?${params}`);
    return response.data;
  },

  // Get single listing by ID
  getListing: async (id) => {
    const response = await apiClient.get(`/listings/${id}`);
    return response.data;
  },

  // Create new listing
  createListing: async (listingData) => {
    const response = await apiClient.post('/listings', listingData);
    return response.data;
  },

  // Update listing
  updateListing: async (id, listingData) => {
    const response = await apiClient.patch(`/listings/${id}`, listingData);
    return response.data;
  },

  // Delete listing
  deleteListing: async (id) => {
    const response = await apiClient.delete(`/listings/${id}`);
    return response.data;
  },

  // Get user's listings
  getUserListings: async (userId) => {
    const response = await apiClient.get(`/listings/user/${userId}`);
    return response.data;
  },

  // Get featured listings
  getFeaturedListings: async () => {
    const response = await apiClient.get('/listings/featured');
    return response.data;
  },

  // Update listing status (admin)
  updateListingStatus: async (id, status) => {
    const response = await apiClient.patch(`/listings/${id}/status`, { status });
    return response.data;
  },
};
